<template>
	<div class="passhot">
		<back-to></back-to>
		<section class="visaList">
			<div class="visaList-item" v-for="(item,index) in data_product_array" :key="index">
				<span class="visaList-item_left">
					<img :src="item.visaImg" alt="">
					<label for="">
						<font>{{item.Country}}</font>
						<p>{{item.VisaCity}}送签</p>
					</label>
				</span>
				<span class="visaList-item_right">
					<h2>{{item.visaName}}</h2>
					<p v-if="item.JXPrice != null || item.JXPrice !=''">{{item.JXPrice}}</p>
					<p v-if="item.JXPrice == null || item.JXPrice ==''">签证时长:{{item.handleTime}}</p>
					<label for="">
						￥{{item.visaPrice}}
						<font>起</font>
					</label>
				</span>
			</div>
		</section>
	</div>
</template>

<script>
	import BackTo from '@/components/BackTo.vue'
	export default {
		name: 'passhot',
		components: {
			BackTo
		},
		data() {
			return {
				data_product_array: []
			}
		},
		computed: {

		},
		mounted() {
			this.getList()
		},
		methods: {
			getList() {
				var mydata = {
					"tohrequest": {
						"callid": "141028",
						"transid": "1555289640259",
						"timestamp": "1555289640259",
						"ostype": "1",
						"imei": "imei",
						"imsi": "imsi",
						"version": "4.0.4",
						"svccont": {
							"areaId": this.$route.query.areaId
						}
					}
				}
				this.$post(
					this.$service + '/m/m_Service.asmx/M_InterfaceTrue', {
						s: JSON.stringify(mydata)
					}
				).then(res => {
					let jsArr = JSON.parse(res.d).tohresponse.svccont.visalist
					console.log(jsArr)
					this.data_product_array = jsArr
				})
			},
		}
	}
</script>
<style scoped>
	.visaList {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
	}

	.visaList-item {
		width: 100%;
		border-bottom: 1px solid #e5e5e5;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px 0;
	}

	.visaList-item_left {
		width: 33%;
		position: relative;
	}

	.visaList-item_left img {
		height: 170px;
		width: 100%;
		border-radius: 15px;
	}

	.visaList-item_left label {
		border-radius: 15px;
		height: 170px;
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.visaList-item_left label font {
		height: 44px;
		line-height: 44px;
		text-align: center;
		padding-left: 15px;
		padding-right: 15px;
		background-color: rgba(0, 0, 0, .7);
		border-top-left-radius: 15px;
		border-bottom-right-radius: 15px;
		color: #FFF;
		font-size: 24px;
		width: fit-content;
	}

	.visaList-item_left label p {
		height: 44px;
		line-height: 44px;
		width: 100%;
		text-align: center;
		background-color: rgba(0, 0, 0, .7);
		color: #ffb42e;
		font-size: 24px;
		border-bottom-right-radius: 15px;
		border-bottom-left-radius: 15px;
	}

	.visaList-item_right {
		width: 65%;
		float: right;
		overflow: hidden;
		height: 170px;
		display: flex;
		flex-direction: column;
	}

	.visaList-item_right h2 {
		font-size: 27px;
		width: 100%;
		color: #333;
		font-weight: bold;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.visaList-item_right p {
		font-size: 24px;
		margin-top: 10px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.visaList-item_right label {
		font-size: 30px;
		color: #ff6d00;
		float: right;
		font-weight: bold;
		margin-top: auto;
		margin-left: auto;
		display: flex;
		align-items: center
	}

	.visaList-item_right font {
		color: #666;
		font-size: 24px;
		padding-left: 7px;
	}
</style>
